<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <div class="d-flex-column justify-start align-start gap-5">
      <h5 class="t-white font-family-1 title-h5">
        {{ $t("new.raid_difficulty") }}
      </h5>
      <p class="regular-l font-family-2 t-grey">
        {{ $t("new.select_raid_difficulty") }}
      </p>
    </div>

    <div class="extra_option_picker d-flex-row space-between sm-row-to-col">
      <button
        class="difficulty_picker b-radius-9 flex-4"
        v-for="difficulty in difficulties"
        :class="[
          checkoutStore.getDetails?.difficultyId === difficulty.id && 'active',
          difficulty.title.toLowerCase(),
        ]"
        @click="selectDifficulty(difficulty)"
      >
        <!-- <img
                    :src="`/images/games/world-of-warcraft-boost/difficulties/${difficulty.title.toLowerCase()}.webp`"
                    alt="diffculty image"
                    class="difficulty_image"
                /> -->
        <p class="t-white bold-xxl font-family-2">
          {{ difficulty.title }}
        </p>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    difficulties() {
      if (this.getGamePack?.prices) {
        return this.getGamePack?.prices;
      }
      return [];
    },
  },

  methods: {
    selectDifficulty(difficulty) {
      if (this.checkoutStore.getSelectedRaid?.id) {
        this.checkoutStore.setRaid(null);
      }
      this.checkoutStore.setDetails({
        ...this.checkoutStore.getDetails,
        difficultyId: difficulty.id,
        difficultyTitle: difficulty.title,
      });
    },
  },
  setup() {
    const checkoutStore = useCheckoutStore();
    const { getGamePack } = useGameStore();
    return {
      checkoutStore,
      getGamePack,
    };
  },
};
</script>
